import { ButtonSize } from 'components/Button/Types'
import { useLayout } from 'stores/LayoutStore'
import { observer } from 'mobx-react-lite'
import { RightRail } from 'blaze-ui/icons'
import { Button } from './Button'
import { useIsSystemRedesign } from 'hooks/useIsSystemRedesign'
import { IconButton } from 'blaze-ui/IconButton/IconButton'

interface Props {
  size?: ButtonSize
  onPress?: (isLocked: boolean) => void
}

export const RightColumnLockButton = observer(({ size = 'md', onPress }: Props) => {
  const isSystemRedesignEnabled = useIsSystemRedesign()
  const layout = useLayout()

  if (isSystemRedesignEnabled) {
    return (
      <IconButton
        icon={RightRail}
        onPress={() => {
          const locked = !layout.rightColumnLocked
          onPress?.(locked)
          layout.setRightColumnLocked(locked)
        }}
        variant="secondary"
        size="md"
        aria-label={layout.rightColumnLocked ? 'Close' : 'Open'}
      />
    )
  }

  return (
    <Button
      data-testid="unlock-right-rail-button"
      onPress={() => {
        const locked = !layout.rightColumnLocked
        onPress?.(locked)
        layout.setRightColumnLocked(locked)
      }}
      aria-label={layout.rightColumnLocked ? 'Close' : 'Open'}
      icon={RightRail}
    />
  )
})
